import { AxiosResponse } from 'axios';

import { ProductCount } from '../pages/outlet-crew/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessPostProductCount extends ResponseREST {
	data: [];
}

export const postProductCount = async (
	idScheduler: number,
	productId: number,
	body: ProductCount,
): Promise<ResponseSuccessPostProductCount> => {
	return axiosInstance
		.post(`add-product-counted/${idScheduler}/${productId}`, body)
		.then((res: AxiosResponse<ResponseSuccessPostProductCount>) => res.data)
		.catch((err) => err);
};
